import { NgModule } from '@angular/core';

import { CommonUIModule } from '../common-ui';

import { JumbotronComponent } from './jumbotron';

@NgModule({
  declarations: [JumbotronComponent],
  exports: [JumbotronComponent],
  imports: [CommonUIModule],
})
export class JumbotronModule {}
